module.exports = __webpack_public_path__ + "img/Hydrus.967cd4f7.png";